import React, { useRef } from 'react';
import { arrayOf, bool, string } from 'prop-types';
import classnames from 'classnames';
import FiverrLogo from '@fiverr-private/icons/logos/fiverr_logo_nav';
import { gigShape } from '../../utils/propTypes';
import { useBQ } from '../../hooks/useBQ';
import { useWidgetImpression } from '../../hooks/useAfp1Impression';
import { sendMixpanelWidgetClickEvent } from '../../utils/mixpanel';
import { GigCard } from '../GigCard';
import { GigMockCard } from '../GigMockCard';
import { ExploreMoreServices } from '../ExploreMoreServices';
import { TrackingLink } from '../TrackingLink';
import { GigCardNew } from '../GigCardNew';
import styles from './style.module.scss';

export const GigsListing = ({
    gigs,
    widgetTitle,
    affiliateId,
    exploreSlug,
    utmCampaign,
    brand,
    afp,
    afp1,
    widgetMoreButton,
    widgetType,
    inGigWidgetsMigration,
}) => {
    const ref = useRef();

    const clickName = 'fiverr_logo_link';
    const clickSection = 'fiverr_name';

    const { sendBQEvent } = useBQ();

    useWidgetImpression({ affiliateId, afp1, widgetType }, ref);

    const onFiverrClick = () => {
        sendBQEvent({
            type: 'nga.fiverr_name_click',
            affiliateId,
            widgetType,
            afp1,
        });
        sendMixpanelWidgetClickEvent({
            affiliateId,
            clickName,
            clickSection,
            hostReference: afp1,
        });
    };
    const marketingParams = {
        affiliateId,
        utmCampaign,
        brand,
        afp,
        afp1,
        afp2: clickName,
        afp3: clickSection,
        widgetType,
    };
    const useLargeImage = gigs.length === 1;
    const useMockGig = gigs.length === 0;

    return (
        <div className={styles.holder} ref={ref}>
            <div className={classnames(styles.center, styles[`length-${gigs.length}`], styles.widget)}>
                {widgetTitle && <h1 className={styles.title}>{widgetTitle}</h1>}
                <div className={styles.body}>
                    <div className={classnames(styles.gigs, styles.divider)}>
                        {useMockGig && <GigMockCard />}
                        {gigs.map((gig) => (
                            <div className={classnames(styles.divider, styles['gig-holder'])} key={gig.id}>
                                {inGigWidgetsMigration ? (
                                    <GigCardNew gig={gig} {...marketingParams} horizontal={useLargeImage} />
                                ) : (
                                    <GigCard
                                        className={styles.gig}
                                        useLargeImage={useLargeImage}
                                        gig={gig}
                                        widgetType={widgetType}
                                        afp1={afp1}
                                        {...marketingParams}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                    <div className={classnames(styles.actions, { [styles['justify-end']]: !exploreSlug })}>
                        {exploreSlug && (
                            <ExploreMoreServices
                                className={styles['service-button']}
                                affiliateId={affiliateId}
                                widgetType={widgetType}
                                brand={brand}
                                afp={afp}
                                afp1={afp1}
                                utmCampaign={utmCampaign}
                                exploreSlug={exploreSlug}
                            >
                                {widgetMoreButton}
                            </ExploreMoreServices>
                        )}
                        <TrackingLink className={styles.brand} onClick={onFiverrClick} {...marketingParams}>
                            <div className={styles['services-prefix']}>Services on </div>
                            <FiverrLogo />
                        </TrackingLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const propTypes = {
    gigs: arrayOf(gigShape),
    widgetTitle: string,
    affiliateId: string,
    exploreSlug: string,
    utmCampaign: string,
    brand: string,
    afp: string,
    afp1: string,
    widgetMoreButton: string,
    widgetType: string,
    inGigWidgetsMigration: bool,
};

GigsListing.propTypes = propTypes;
